import { cryptoKeyToBase64 } from '@lucidlink/ts-crypto/crypto';
export const generateInvitation = async (params) => {
    const linkSecret = await cryptoKeyToBase64(params.linkSecret);
    return {
        id: params.invitationId,
        linkSecret,
        isEncrypted: false,
    };
};
